import {
    ADD_PAYER,
    GET_PAYERS,
    EDIT_PAYER,
    DELETE_PAYER,
    GET_PAYER_RATES,
    ADD_PAYER_RATE,
    EDIT_PAYER_RATE,
    DELETE_PAYER_RATE,
    CHANGE_STATUS_PAYER,
    GET_MOMENTM_PAYER,
    CONNECT_MOMENTM_PAYER,
    EDIT_MOMENTM_PAYER,
    EDIT_STATUS_MOMENTM_PAYER, GET_PAYER_SINGLE, PAYER_ENABLE_TIME, EDIT_PAYER_TIME_RULES,
} from "./payer.types";

export const getPayers = (params, noLoad = false) => {
    return {
        type: GET_PAYERS,
        payload: {
            params,
            noLoad,
        },
    };
};

export const getPayerSingle = (payerId, params, noLoad = false) => {
    return {
        type: GET_PAYER_SINGLE,
        payload: {
            payerId,
            params,
            noLoad,
        },
    };
};

export const addPayer = (body) => {
    return {
        type: ADD_PAYER,
        payload: {
            body,
        },
    };
};

export const editPayer = (id, body) => {
    return {
        type: EDIT_PAYER,
        payload: {
            id,
            body,
        },
    };
};

export const deletePayer = (id) => {
    return {
        type: DELETE_PAYER,
        payload: {
            id,
        },
    };
};

export const changeStatus = (id, body) => {
    return {
        type: CHANGE_STATUS_PAYER,
        payload: {
            id,
            body,
        },
    };
};

/** Connect Momentm to Payer */

export const getMomentmToPayer = (id) => {
    return {
        type: GET_MOMENTM_PAYER,
        payload: {
            id,
        },
    };
};

export const connectMomentmToPayer = (body) => {
    return {
        type: CONNECT_MOMENTM_PAYER,
        payload: {
            body
        },
    };
};

export const editMomentmToPayer = (payerId, body) => {
    return {
        type: EDIT_MOMENTM_PAYER,
        payload: {
            id: payerId,
            body,
        },
    };
};

export const editMomentmStatus = (payerId, body) => {
    return {
        type: EDIT_STATUS_MOMENTM_PAYER,
        payload: {
            id: payerId,
            body,
        },
    };
};
/** End */

export const getPayerRates = (params, noLoad = false) => {
    return {
        type: GET_PAYER_RATES,
        payload: {
            params,
            noLoad
        },
    };
};

export const addPayerRate = (body) => {
    return {
        type: ADD_PAYER_RATE,
        payload: {
            body,
        },
    };
};

export const editPayerRate = (id, body) => {
    return {
        type: EDIT_PAYER_RATE,
        payload: {
            id,
            body,
        },
    };
};

export const deletePayerRate = (id) => {
    return {
        type: DELETE_PAYER_RATE,
        payload: {
            id,
        },
    };
};

/** Appt Time Rules*/
export const editPayerTimeRules = (payerId, body) => {
    return {
        type: EDIT_PAYER_TIME_RULES,
        payload: {
            payerId,
            body
        },
    };
}
export const enablePayerApptTime = (payerId, body) => {
    return {
        type: PAYER_ENABLE_TIME,
        payload: {
            payerId,
            body
        },
    };
}
